// Conversation titles are rendered as a single ellipsised line, where markdown markup is
// noise rather than formatting — drop the syntax and keep the text it decorates.
export const stripMarkdown = (text: string): string =>
  text
    .replace(/`{1,3}([^`]*)`{1,3}/g, '$1')
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')
    .replace(/^\s{0,3}>\s?/gm, '')
    .replace(/^\s*(?:[-*+]|\d+\.)\s+/gm, '')
    .replace(/^\s*(?:[-*_]\s*){3,}$/gm, '')
    .replace(/(\*\*|__)(.+?)\1/g, '$2')
    .replace(/~~(.+?)~~/g, '$1')
    .replace(/(^|[^\w*])\*(?!\s)([^*]+?)\*(?![\w*])/g, '$1$2')
    .replace(/(^|[^\w_])_(?!\s)([^_]+?)_(?![\w_])/g, '$1$2')
    .replace(/\s+/g, ' ')
    .trim()
